import Onboarding, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/onboarding';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Onboarding;
